import type {Meta, StoryObj} from '@storybook/angular';
import {applicationConfig, moduleMetadata} from '@storybook/angular';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideHttpClient} from '@angular/common/http';
import {provideRouter} from '@angular/router';
import {of} from 'rxjs';

import {HeaderComponent} from '../app/content/layout/components/general/header/header.component';
import {UserService} from '../app/core/services/user.service';
import {StoryblokService} from '../app/core/services/storyblok.service';
import {TrackEventService} from '../app/core/services/track-event.service';
import {RoutingService} from '../app/core/services/routing.service';
import {StoreConfigService} from '../app/core/services/store-config.service';
import {AlgoliaService} from '../app/core/services/algolia.service';
import {StoryblokStylingService} from '../app/core/services/storyblok-styling.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

function createUserServiceMock(isLimitedToGroupVoucher: boolean) {
  const user = {
    id: 123,
    limitedToGroupVoucher: isLimitedToGroupVoucher,
    groupVoucher: {
      redirectTo: '/voucher/list'
    }
  };

  return {
    userSignal: () => user,
    customerFirstnameSignal: () => 'Anders',
    currentUser: () => user,
  };
}

class MockStoryblokService {
  storyblokMenuInputChange = of(null);

  getImageUrl(options: { filename: string }) {
    return options.filename;
  }

  isPreviewStoryblokPage() {
    return false;
  }

  getStoryPromise() {
    return Promise.resolve({
      story: {
        content: {
          Menu: [
            {
              Name: 'Vin',
              component: 'Menu',
              Link: {url: '/vin'}
            }
          ]
        }
      }
    });
  }
}

class MockTrackEventService {
  trackClickEvent() {
    return undefined;
  }
}

class MockRoutingService {
  routerSignal = () => '/';

  onRouteChange() {
    return of('/');
  }

  getQueryParams() {
    return {};
  }
}

class MockStoreConfigService {
  storeConfig = () => ({
    minimumFreightPrice: 19,
    freeDeliveryStartsFrom: 1000,
  });
}

class MockAlgoliaService {
  searchConfig() {
    return () => null;
  }
}

class MockStoryblokStylingService {
  getClassList() {
    return [];
  }
}

const meta: Meta<HeaderComponent> = {
  title: 'Organisms/App Header',
  component: HeaderComponent,
  tags: ['autodocs'],
  decorators: [
    moduleMetadata({
      imports: [HeaderComponent],
      providers: [
        {provide: StoryblokService, useClass: MockStoryblokService},
        {provide: TrackEventService, useClass: MockTrackEventService},
        {provide: RoutingService, useClass: MockRoutingService},
        {provide: StoreConfigService, useClass: MockStoreConfigService},
        {provide: AlgoliaService, useClass: MockAlgoliaService},
        {provide: StoryblokStylingService, useClass: MockStoryblokStylingService},
        {provide: NgbModal, useValue: {open: () => ({componentInstance: {}}), dismissAll: () => undefined}},
      ],
    }),
    applicationConfig({
      providers: [
        provideHttpClient(),
        provideRouter([]),
        provideAnimations()
      ],
    }),
  ],
  parameters: {
    layout: 'fullscreen',
  },
};

export default meta;
type Story = StoryObj<HeaderComponent>;

export const LimitedCollectionBanner: Story = {
  name: 'Limited Collection Banner',
  decorators: [
    moduleMetadata({
      providers: [
        {provide: UserService, useValue: createUserServiceMock(true)},
      ],
    }),
  ],
  render: () => ({
    template: '<app-header />',
  }),
};

export const AssociatedCollectionBanner: Story = {
  name: 'Associated Collection Banner',
  decorators: [
    moduleMetadata({
      providers: [
        {provide: UserService, useValue: createUserServiceMock(false)},
      ],
    }),
  ],
  render: () => ({
    template: '<app-header />',
  }),
};